<svg [climbIcon]="icons.plusCircleFilled"></svg>
<span #buttonLabel class="button-label"><ng-content></ng-content></span>
